import TagsModel from './TagsModel'

export default class TagsListModel {
  constructor (data) {
    if (Array.isArray(data)) {
      this.list = this.groupBy(data, 'name')
      this.categories = Object.keys(this.list)
    }
  }

  groupBy (array, key) {
    /**
     * data = [{ name: "A", value: "1"}, { name: "A", value: "2"}]
     * groupBy(data, "name") => { A: [{ name: "A", value: "1"}, { name: "A", value: "2"}] }
     */
    return array.reduce((result, item) => {
      (result[item[key]] = result[item[key]] || []).push(new TagsModel(item))
      return result
    }, {})
  }

  addTag (tag) {
    if (!Array.isArray(this.list[tag.name])) {
      this.list[tag.name] = []
    }
    const exists = this.list[tag.name].some((item) => item.id === tag.id)
    if (!exists) {
      this.list[tag.name].push(tag)
    }
  }

  removeTag (tag) {
    if (Array.isArray(this.list[tag.name])) {
      this.list[tag.name] = this.list[tag.name].filter(
        (item) => item.id !== tag.id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/tags/TagsListModel.js